import { getPhoneToApi } from 'src/utils';
import type { IClientInfo } from 'src/interfaces';

export const mapClientToApi = ({
  email,
  lastName,
  firstName,
  message,
  phone,
  countryCode,
}: IClientInfo) => ({
  ...(message && { note: message }),
  client: {
    email,
    firstname: firstName,
    lastname: lastName,
    phone: getPhoneToApi(phone, countryCode),
  },
});
